import { Configuration, LogLevel } from "@azure/msal-browser";
import { CONFIG } from "../../config";

export const msalConfig: Configuration = {
  auth: {
    clientId: CONFIG.AUTH_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${CONFIG.AUTH_TENANT_ID}`,
    redirectUri: CONFIG.REDIRECT_URI,
    postLogoutRedirectUri: CONFIG.REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: { cacheLocation: "localStorage", storeAuthStateInCookie: false },
  system: {
    loggerOptions: {
      loggerCallback(level, message, containsPii) {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        if (level === LogLevel.Warning) console.warn(message);
      },
    },
  },
};

export const loginRequest = {
  scopes: [CONFIG.AUTH_SCOPE],
};
